/**
 * Note this is not a fragment
 * @type {string}
 */
export const baseFields = `
id
createdAt
updatedAt
creator {
  ...userFragment
}
updater {
  ...userFragment
}
`;

export const userFragment = `
fragment userFragment on User {
  id
  name
}
`;

export const criteriaFragment = `
fragment criteriaFragment on Criteria {
  ${baseFields}
  title
  explanation
  type
}
`;

export const groupCriteriaFragment = `
fragment groupCriteriaFragment on GroupCriteria {
  ${baseFields}
  name
}
`;

export const reviewSessionFragment = `
fragment reviewSessionFragment on ReviewSession {
  ${baseFields}
  status
  period
}
`;

export const reviewFormFragment = `
fragment reviewFormFragment on ReviewForm {
  ${baseFields}
  status
  target {
    ...userFragment
  }
  author {
    ...userFragment
  }
}
`;

export const reviewPointFragment = `
fragment reviewPointFragment on ReviewPoint {
  ${baseFields}

  criteriaId
  reviewFormId
  point
  comment
  type
}
`;
